import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Icon, IconColor } from "@/components/shared/Icon"
import { RootState } from "@/store"
import { selectIsRealtimeConnectionStale } from "@/store/websocketSlice"

const CONNECTION_CHECK_INTERVAL_MS = 5000

const ConnectionLostWarning = () => {
   const [now, setNow] = useState(Date.now)

   useEffect(() => {
      const timer = setInterval(
         () => setNow(Date.now()),
         CONNECTION_CHECK_INTERVAL_MS
      )
      return () => clearInterval(timer)
   }, [])

   const isConnectionLost = useSelector((state: RootState) =>
      selectIsRealtimeConnectionStale(state, now)
   )

   if (!isConnectionLost) return null

   return (
      <div
         className="floor-overview__data-warning-info"
         role="alert"
      >
         <Icon
            name="alert"
            size="24"
            color={IconColor.XANTHOUS}
         />
         Connection lost - data may be stale
      </div>
   )
}

export default ConnectionLostWarning
